import { jsx } from "panel";
import { LineChartEl } from "common/charts/visualization/line-chart";
import { NoDataHero } from "common/widgets/warning-hero/presets";
import { WarningHeroReportName } from "common/widgets/warning-hero/constants";
import { SegmentLegendHeaderEl } from "common/charts/misc/segment-legend-header";
import { formatMetricNumber } from "common/util";
import { LENGTH, SIZE, TextHighlightEl, THEME } from "common/components/text-highlight";
import { TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
import { LIFT_TOOLTIP_COMPARE } from "common/report/util/lift/types";
import { formatLiftPercent } from "common/report/util/lift";
import { formatNumber } from "common/report/retention/util";
import { ActionsPopoverEl } from "common/widgets/actions-popover";
export function template() {
  var _a, _b, _c, _d, _e, _f;
  if (!this.helpers.hasResults()) {
    return /* @__PURE__ */ jsx("div", {
      sel: ".retention-curve-chart"
    }, /* @__PURE__ */ jsx(NoDataHero, {
      reportName: WarningHeroReportName.Retention
    }));
  }
  return /* @__PURE__ */ jsx("div", {
    sel: ".root"
  }, /* @__PURE__ */ jsx(SegmentLegendHeaderEl, {
    sel: ".segment-header"
  }), /* @__PURE__ */ jsx(LineChartEl, {
    sel: ".line-chart",
    attrs: this.helpers.getLineChartAttrs(),
    props: this.helpers.getLineChartProps(),
    key: this.helpers.getChartType(),
    hook: {
      insert: ({ elm }) => {
        this.chartResizeObserver.observe(elm);
      },
      remove: ({ elm }, removeCallback) => {
        this.chartResizeObserver.unobserve(elm);
        removeCallback();
      }
    }
  }), this.attr(`show-popover`) && this.popoverProp && this.state.selectedHighchartsPoint ? /* @__PURE__ */ jsx(ActionsPopoverEl, {
    on: { ...(_b = (_a = this.popoverProp) == null ? void 0 : _a.call(this)) == null ? void 0 : _b.eventHandlers(), close: this.helpers.closePopover },
    style: this.state.popoverStyles,
    attrs: { ...(_d = (_c = this.popoverProp) == null ? void 0 : _c.call(this)) == null ? void 0 : _d.attrs(), ...{ open: !!this.popoverProp } }
  }, (_f = (_e = this.popoverProp) == null ? void 0 : _e.call(this)) == null ? void 0 : _f.body()) : null);
}
export function getDataCellRenderer(hasLift, isPct) {
  return function({ item, context }) {
    const cell = item.cells.length > context.field ? item.cells[context.field] : null;
    if (cell) {
      const mainDisplayValue = isPct ? cell.formatted_percent : cell.formatted_value;
      const coreCellContent = `${mainDisplayValue}${cell.incomplete ? `*` : ``}`;
      if (hasLift) {
        const liftField = item[context.liftField];
        const liftExtra = item[context.liftExtra];
        const isPositive = liftField > 0;
        const tooltipBaselineDisplayValue = isPct ? `${formatMetricNumber(Number((100 * liftExtra).toFixed(2)))}%` : `${formatNumber(liftExtra)}`;
        return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
          sel: ".mp-table-cell"
        }, coreCellContent, /* @__PURE__ */ jsx(TextHighlightEl, {
          sel: ".mp-lift-pill",
          attrs: {
            text: formatLiftPercent(liftField),
            theme: isPositive ? THEME.POSITIVE : THEME.NEGATIVE,
            size: SIZE.SMALL,
            length: LENGTH.THIN
          }
        }), /* @__PURE__ */ jsx(TooltipEl, {
          attrs: {
            placement: Placement.Top,
            text: `${mainDisplayValue} ${LIFT_TOOLTIP_COMPARE} ${tooltipBaselineDisplayValue}`
          }
        })));
      }
      return coreCellContent;
    }
    return void 0;
  };
}
